module.exports = __webpack_public_path__ + "files/SPIADI2024 - Rapport national OBSERVA4 - janvier 2026.b6e82a79e01cf48196c6aee75f6d9dae.pdf";